import { useState, useEffect, useRef } from 'react';

enum OperatingSystem {
  Windows = 'Windows',
  Mac = 'Mac',
  Unknown = 'Unknown',
}

export const useReminderPopup = (delay: number = 10 * 60 * 1000) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [hasPopupBeenShown, setHasPopupBeenShown] = useState(false);
  const popupTimerRef = useRef<NodeJS.Timeout | null>(null);
  const [operatingSystem, setOperatingSystem] = useState<OperatingSystem>(OperatingSystem.Unknown);

  const detectOperatingSystem = (): OperatingSystem => {
    const userAgent = navigator.userAgent.toLowerCase();
  
    if (userAgent.includes('win')) {
      return OperatingSystem.Windows;
    } else if (userAgent.includes('mac')) {
      return OperatingSystem.Mac;
    }

    return OperatingSystem.Unknown;
  };

  useEffect(() => {
    setOperatingSystem(detectOperatingSystem());

    popupTimerRef.current = setTimeout(() => {
      if (!hasPopupBeenShown) {
        setIsPopupVisible(true);
        setHasPopupBeenShown(true);
      }
    }, delay);

    const handleMouseMovement = (event: MouseEvent) => {
      const { clientX, clientY } = event;
      let isCloseToExit = false;

      const detectionBoundary = 100;

      if (operatingSystem === OperatingSystem.Windows) {
        isCloseToExit = clientY < detectionBoundary && clientX > window.innerWidth - detectionBoundary;
      } else if (operatingSystem === OperatingSystem.Mac) {
        isCloseToExit = clientY < detectionBoundary && clientX < detectionBoundary;
      }

      if (isCloseToExit && !hasPopupBeenShown) {
        setIsPopupVisible(true);
        setHasPopupBeenShown(true);
        if (popupTimerRef.current) {
          clearTimeout(popupTimerRef.current);
        }
      }
    };

    window.addEventListener('mousemove', handleMouseMovement);

    return () => {
      if (popupTimerRef.current) {
        clearTimeout(popupTimerRef.current);
      }
      window.removeEventListener('mousemove', handleMouseMovement);
    };
  }, [operatingSystem, delay, hasPopupBeenShown]);

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  return { isPopupVisible, setIsPopupVisible, closePopup };
};